type Case = 'kebab' | 'snake'

export const useLicensedTerritory = (
  options: {
    case?: Case
    raw?: boolean
  } = { case: 'kebab', raw: false },
) => {
  const { licensedTerritory } = useRuntimeConfig().public
  return options.raw
    ? licensedTerritory
    : options.case === 'kebab'
      ? licensedTerritory.toLowerCase()
      : licensedTerritory.toLowerCase().replace('-', '_')
}
